/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework from '@greenville/framework';
import error from './error';
import users from './users';
import aiadmin from './aiadmin';
import studio from './studio';
import salesBot from './salesBot';

import env from '../common/env';

Framework.getClientManager().add({
  name: 'aiadmin',
  authHeader: 'authorization',
  timeout: env.AI_ADMIN_API_TIMEOUT,
  baseUrl: env.AI_ADMIN_API_BASE_URL,
  tokenPrefix: 'Bearer '
});
Framework.getClientManager().add({
  name: 'aiadminv2',
  authHeader: 'authorization',
  timeout: env.AI_ADMIN_API_TIMEOUT,
  baseUrl: env.AI_ADMIN_API_BASE_URL_V2,
  tokenPrefix: 'Bearer '
});
Framework.getClientManager().add({
  name: 'aiadminv3',
  authHeader: 'authorization',
  timeout: env.AI_ADMIN_API_TIMEOUT,
  baseUrl: env.AI_ADMIN_API_BASE_URL_V3,
  tokenPrefix: 'Bearer '
});
Framework.getClientManager().add({
  name: 'berlin',
  timeout: env.AI_ADMIN_API_TIMEOUT,
  baseUrl: env.BERLIN_API_URI
});
Framework.getClientManager().add({
  name: 'aiadminstackb',
  timeout: env.AI_ADMIN_API_TIMEOUT,
  baseUrl: env.AI_ADMIN_API_BASE_URL_STACKB
});
Framework.getClientManager().add({
  name: 'aiadminstackbv2',
  timeout: env.AI_ADMIN_API_TIMEOUT,
  baseUrl: env.AI_ADMIN_API_BASE_URL_V2_STACKB
});
Framework.getClientManager().add({
  name: 'aiadminstackbv3',
  timeout: env.AI_ADMIN_API_TIMEOUT,
  baseUrl: env.AI_ADMIN_API_BASE_URL_V3_STACKB
});

export default [users, error, aiadmin, studio, salesBot];
